<template>
  <div class="player-card">
    <div
      :style="{
        '--bg-url': `url(${player.general?.team_logo})`,
      }"
      class="player-card__image"
    >
      <img
        :src="getImageFromProxy(player.general?.avatar || '', '200:200')"
        alt=""
        loading="eager"
      >
    </div>
    <div class="player-card__info f gap8">
      <nuxt-link
        :to="localePath(`/pro-players/${player.general?.nick_name}`)"
        class="player-card__info__name"
      >
        {{ player.general?.nick_name }}
      </nuxt-link>
      <div class="img-wrapper">
        <img
          :src="player.general?.country_logo"
          alt=""
        >
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { ProPlayer } from '~/graphql/generated/schema-types';

defineProps<{
  player: ProPlayer
}>();

const localePath = useLocalePath();
</script>

<style lang="scss" scoped>
.player-card {
  display: flex;
  padding: 16px;
  flex-direction: column;
  gap: 16px;
  border-radius: 12px;
  background: var(--surfaces-low-container);
  position: relative;

  &:hover {
    .player-card__image img {
      transform: scale(1.1);
    }
  }

  &__image {
    width: 140px;
    margin: 0 auto;
    height: unset;
    flex-shrink: 0;
    border-radius: 50%;
    overflow: hidden;
    aspect-ratio: 1/1;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      position: relative;
      z-index: 1;
      margin-top: 10px;
      transition: transform 0.5s;
    }

    &:after, &:before {
      content: '';
      position: absolute;
      inset: 0;
      background-image: var(--bg-url);
      filter: blur(50px);
      background-size: 150%;
      background-position: center;
    }

    @media screen and (max-width: 768px) {
      width: 100%;
      min-width: 100%;
      height: unset;
    }
  }

  &__info {
    &__name {
      color: var(--surfaces-on-surface);
      font-size: 14px;
      font-weight: 600;
      line-height: 18px;

      &:after {
        content: '';
        position: absolute;
        inset: 0;
        z-index: 2;
      }
    }

    .img-wrapper {
      width: 19px;
      height: 19px;
      border-radius: 50%;
      overflow: hidden;
    }

    img {
      width: 100%;
      height: 100%;
      transform: scale(1.5);
      object-position: center;
      object-fit: cover;
    }
  }
}
</style>
